import React from "react";
import {
    Modal,
    message,
    Upload,
    Form,
    Icon,
    InputNumber,
    Input,
    Select,
    Popconfirm,
    Button,
    Divider,
} from "antd";
import _ from "lodash";
import Services from "../../../services/categories";
import ItemFormHelper from "./../itemForm/ItemFormHelper";
import CKEditor from 'ckeditor4-react';
import { InboxOutlined } from '@ant-design/icons';
const { Dragger } = Upload;
const types = ["application/pdf", "application/vnd.openxmlformats-officedocument.wordprocessingm", "application/msword"];

// select-option
const Option = Select.Option;

//   upload-script end
let PreviewFromLink = {
    _id: "",
    uid: "",
    name: "",
    status: "done",
    response: "ok",
    url: "",
};

class PrintableForm extends React.Component {
    // form-scripts start
    handleFormLayoutChange = (e) => {
        this.setState({ formLayout: e.target.value });
    };

    constructor() {
        super();
        this.state = {
            formLayout: "horizontal",
            previewVisible: false,
            addOption: false,
            visible: false,
            addItem: false,
            previewImage: "",
            printable: { title: [], description: [], pdfUrl: [], fields: [], _id: [] },
            sortNo: "",
            fileList: [],
            imageFiles: [],
            filteredInfo: null,
            sortedInfo: null,

            pdfFiles: [],
            files: [],
        };
    }

    componentDidUpdate(prevProps, prevState) {
        const { editFormContents } = this.props;

        if (!_.isEqual(prevProps.editFormContents, editFormContents)) {

            if (editFormContents?.length) {
                const title = [], description = [], pdfUrl = [], fields = [], fileList = [], _id = [];
                const formattedPrintableData = editFormContents[0].printable?.map((item) => {
                    _id.push(item?._id);
                    title.push(item?.title);
                    fields.push("");
                    description.push(item?.description);
                    pdfUrl.push(item.pdfUrl)
                    fileList.push([
                        {
                            ...PreviewFromLink,
                            _id: item?._id,
                            uid: item?.image,
                            name: item?.name,
                            url: `/api/util/image?key=${item?.image}`,
                        },
                    ]);
                });

                this.setState({
                    printable: { title, description, pdfUrl, fields, _id },
                    fileList,
                    sortNo: editFormContents[0].sort
                });
            }
        }
    }
    // Modal-scripts start
    showModal = () => {
        this.setState({
            visible: true,
        });
    };
    handleOk = (e) => {
        this.setState({
            visible: false,
        });
    };
    addItem = (e) => {
        this.setState({
            addItem: !this.state.addItem,
        });
    };
    addOption = (e) => {
        this.setState({
            addOption: !this.state.addOption,
        });
    };
    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
    };
    // Modal-scripts end

    // pictureUpload scripts start

    handleCancel = () => this.setState({ previewVisible: false });

    handlePreview = (file) => {
        this.setState({
            previewImage: file.url || file.thumbUrl,
            previewVisible: true,
        });
    };
    handleRemove = (file, i) => {
        this.setState((prev) => {
            if (
                JSON.stringify(prev.imageFiles[i]?.uid) === JSON.stringify(file?.uid)
            ) {
                // prev.imageFiles.splice(i, 1);
                prev.imageFiles[i] = null;
            }
            delete prev.fileList[i];
            return { ...prev };
        });
    };
    handleUploadBegin = (file, i) => {
        this.setState((prev) => {
            prev.imageFiles[i] = file;
            return {
                imageFiles: prev.imageFiles,
            };
        });
    };
    handleChange = (e, index) => {
        this.setState((prev) => {
            prev.fileList[index] = e.fileList;
            return { fileList: prev.fileList };
        });
    };

    handlePdfUploadBegin = (file, i) => {
        if (!types.includes(file.type)) {
            message.error(`${file.name} is not a pdf file`);
        } else {
            this.setState((prev) => {
                prev.pdfFiles[i] = file;
                return {
                    pdfFiles: prev.pdfFiles,
                };
            });

        }
    };

    handlePdfChange = (e, index) => {
        this.setState((prev) => {
            prev.files[index] = e.fileList;
            return { files: prev.files };
        });
    };

    customRequest = ({ file, onSuccess }) => {
        if (file.status !== "uploading") {
        }
        if (file.status === "done") {
            message.success(`${file.name} file uploaded successfully`);
        } else if (file.status === "error") {
            message.error(`${file.name} file upload failed.`);
        }
        setTimeout(() => onSuccess("ok"), 0);
    };

    addSortNo = (value) => {
        console.log("sort: ", value);
        this.setState({ sortNo: value })
    }

    // pictureUpload scripts End
    columnGenerator = (id) => {
        return (
            <React.Fragment>
                <div className="ant-row" key={id}>
                    <div className="ant-col-md-12">
                        <Input type="text" placeholder="Add Title" />
                    </div>

                    <div className="ant-col-md-12">
                        <Input type="text" placeholder="Add Description" />
                    </div>

                    <div className="ant-col-md-12">
                        <Input type="text" placeholder="Add Url" />
                    </div>
                </div>
                <br />
            </React.Fragment>
        );
    };

    _renderPrintable = (i) => {
        const addTitle = (e) => {
            e.persist();
            this.setState((prev) => {
                prev.printable.title[i] = e.target.value;
                return {
                    printable: prev.printable,
                };
            });
        };

        const addDescription = async (e) => {
            e.persist();
            this.setState((prev) => {
                prev.printable.description[i] = e.target.value;
                return {
                    printable: prev.printable,
                };
            });
        };
        const onChange = (evt) => {
            const newContent = evt.editor.getData();
            this.setState((prev) => {
                prev.printable.description[i] = newContent;
                return {
                    printable: prev.printable
                };
            });
        }

        const addPdfUrl = async (e) => {
            e.persist();
            this.setState((prev) => {
                prev.printable.pdfUrl[i] = e.target.value;
                return {
                    printable: prev.printable,
                };
            });
        };

        const { previewVisible, previewImage, fileList, files } = this.state;
        const uploadButton = (
            <div>
                <Icon type="plus" />
                <div className="ant-upload-text"><span style={{ color: "red" }}>*</span>Upload</div>
            </div>
        );
        return (
            <div className="ant-row" key={"Printable_" + i}>
                <div className="ant-col-md-8">
                    <Input
                        required
                        type="text"
                        placeholder="Add Title"
                        onChange={addTitle.bind(this)}
                        value={this.state.printable.title[i]}
                    />
                </div>

                <div className="ant-col-md-8">
                <CKEditor
                    activeClass="p10"
                    data={this.state.printable.description[i]}
                    config={{
                      //allowedContent: 'p b i s li ul ol h1 h2 bulletedList numberedlist',
                      extraPlugins: "colorbutton",
                      removePlugins:
                        "horizontalrule,blockquote,sourcearea,pasteFromWord",
                      removeButtons:
                        "Subscript,Superscript,Underline,Image,Save,NewPage,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Find,SelectAll,Scayt,Replace,Form,Checkbox,Textarea,Select,Button,ImageButton,HiddenField,CreateDiv,BidiLtr,BidiRtl,Language,Flash,Smiley,SpecialChar,PageBreak,Iframe,Anchor,ShowBlocks,About,CopyFormatting,Undo,Redo,Table,Insert,Bold,Italic,Strike,RemoveFormat",
                    }}
                    onChange={onChange}
                    // onChange={onChange}
                  />
                    {/* <Input
                        type="text"
                        placeholder="Add Description"
                        value={this.state.printable.description[i]}
                        onChange={addDescription.bind(this)}
                    /> */}
                </div>

                {/* <div className="ant-col-md-8">
                    <Input
                        type="text"
                        placeholder="Add Url"
                        value={this.state.printable.pdfUrl[i]}
                        onChange={addPdfUrl.bind(this)}
                    />
                </div> */}

                <div className="ant-col-md-3 upload-img-main">Thumbnail:
                    <Upload
                        listType="picture-card"
                        fileList={fileList[i]}
                        onPreview={this.handlePreview}
                        customRequest={this.customRequest}
                        beforeUpload={(file) => this.handleUploadBegin(file, i)}
                        onChange={(e) => this.handleChange(e, i)}
                        onRemove={(file) => this.handleRemove(file, i)}
                        accept="image/jpeg, image/png"
                    >
                        {fileList[i]?.length ? null : uploadButton}
                    </Upload>
                    <Modal
                        visible={previewVisible}
                        footer={null}
                        onCancel={this.handleCancel}
                    >
                        <img alt="example" style={{ width: "100%" }} src={previewImage} />
                    </Modal>
                </div>

                <div className="ant-col-md-3 upload-img-main">PDF:
                    <Upload
                        listType="picture-card"
                        fileList={files[i]}
                        // onPreview={this.handlePreview}
                        customRequest={this.customRequest}
                        beforeUpload={(file) => this.handlePdfUploadBegin(file, i)}
                        onChange={(e) => this.handlePdfChange(e, i)}
                        // onRemove={(file) => this.handleRemove(file, i)}
                        accept=".pdf"
                    >
                        {files[i]?.length ? null : uploadButton}
                    </Upload>
                </div>

                {/* <div className="ant-col-md-4 upload-img-main">
                <Dragger 
                ileList={files[i]}
                // onPreview={this.handlePreview}
                customRequest={this.customRequest}
                beforeUpload={(file) => this.handlePdfUploadBegin(file, i)}
                onChange={(e) => this.handlePdfChange(e, i)}
                // onRemove={(file) => this.handleRemove(file, i)}
                accept=".pdf">
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Click or drag file to this area to upload</p>

                </Dragger>
                        </div>  */}

                <div className="ant-col-md-2 ">
                    <div className="action-btn">
                        <a href="" title="Delete">
                            <Popconfirm
                                title="Are you sure delete this ?"
                                onConfirm={() => {
                                    this.setState((prev) => {
                                        Services.removeBanner(this.state.printable._id[i])
                                        delete prev.printable?.fields[i];
                                        delete prev.fileList[i];
                                        return { printable: prev.printable, fileList: prev.fileList };
                                    });
                                }}
                                onCancel={() => { }}
                                okText="Yes"
                                cancelText="No"
                            >
                                <span className="gx-link" title="Delete">
                                    <i class="icon icon-trash"></i>
                                </span>
                            </Popconfirm>
                        </a>
                    </div>
                </div>
                <Divider/>
            </div>
        );
    };
    render() {
        const { formLayout } = this.state;

        // Sort-Table-Scripts-Start
        let { sortedInfo, filteredInfo } = this.state;
        sortedInfo = sortedInfo || {};
        filteredInfo = filteredInfo || {};

        // sort-table-scripts-End

        // PrintableState Setter Start
        ItemFormHelper.setPrintableState({
            printable: this.state.printable,
            images: this.state.imageFiles,
            pdf: this.state.pdfFiles,
            sortNo: this.state.sortNo
        });
        // PrintableState Setter End

        return (
            <Form>
                <div className="ant-row hd-title gx-m-0">
                    <div className="ant-col-md-12">
                        <h1>Manage Printable</h1>
                    </div>
                    <div className="ant-col-md-12 rite-btn">
                        <Button
                            type="primary"
                            className="color-white"
                            onClick={() => {
                                this.setState((prev) => {
                                    prev.printable.fields.push("");
                                    return { printable: prev.printable };
                                });
                            }}
                        >
                            <i class="icon icon-add"></i> Add
            </Button>
                    </div>
                </div>

                <div className="ant-row gx-mt-4">
                    <div className="ant-col-md-24">
                        <div className="item-detail-edit-box">
                            <InputNumber
                                required
                                placeholder="Sort No"
                                onChange={this.addSortNo}
                                value={this.state.sortNo}
                            />
                        </div>
                        <br />
                        <div>
                            {this.state.printable?.fields?.map((item, index) => {
                                return this._renderPrintable(index);
                            })}
                        </div>
                    </div>
                </div>
            </Form>
        );
    }
}

export default PrintableForm;
